export default __webpack_public_path__ + "static/media/spell8.0f5ba5d8.jpg";